export function scrollIntoView(
  element: HTMLElement | undefined | null,
  params?: ScrollIntoViewOptions
): void {
  if (!element) {
    return
  }
  element.setAttribute(SCROLL_INTO_VIEW_ATTRIBUTE, 'true') // This is used by useScrollRestoration to prevent the scroll position from being restored if a child has scrolled into view.
  element.scrollIntoView(params)
}

const SCROLL_INTO_VIEW_ATTRIBUTE = 'data-scroll-into-view'
export const SCROLLED_INTO_VIEW_SELECTOR = `[${SCROLL_INTO_VIEW_ATTRIBUTE}="true"]`
